import { createReducer } from '@reduxjs/toolkit';
import {
    SET_IS_LOADING_CLIENTS_DATA,
    SET_CLIENTS_DATA,
    SET_CLIENTS_SINGLE_DATA,
    SET_CLIENTS_SINGLE_SLUG,
} from '../actions/clientsActions';

const initialState = {
    clientsData: [],
    allLocations: [],
    clientsSingleData: {},
    isLoadingClientsData: true,
    clientsSingleSlug: '',
};

const Clients = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_CLIENTS_DATA, (state, action) => {
            state.clientsData = action.clientsData;
            state.allLocations = action.allLocations;
        })
        .addCase(SET_CLIENTS_SINGLE_DATA, (state, action) => {
            state.clientsSingleData = action.clientsSingleData;
        })
        .addCase(SET_IS_LOADING_CLIENTS_DATA, (state, action) => {
            state.isLoadingClientsData = action.isLoading;
        })
        .addCase(SET_CLIENTS_SINGLE_SLUG, (state, action) => {
            state.clientsSingleSlug = action.slug;
        });
});

export default Clients;
